import { ActionFunctionArgs, redirect } from 'react-router-dom';

export async function loginAction({ request }: ActionFunctionArgs) {
  const formData = await request.formData();
  const data = Object.fromEntries(formData);
  console.log(data);
  return redirect('/');
}
